/* ⚛ REACT */
import { useState } from "react";

/* 📦 LIBS */
import { useNavigate } from "react-router";

/* 🧠 REDUX */
import { store } from '../../../../Redux/Store';
import { useSelector } from "react-redux/es/hooks/useSelector";
import { LogOut } from '../../../../Redux/Actions';

/* 📁 ASSETS*/
import { LogOutIcon } from "../../../../Assets/icons/MenuIcons";

/* 🎨 STYLES */
import { Container, Content, ProfileImage, LogOutContainer, LogOutImage, LogOutText, NameContainer, NameText} from "./styles";

function MobileHeader(){
    const navigate = useNavigate();
    const user = useSelector(state => state.userReducer);
    const [height, setHeight] = useState(true);

    window.addEventListener('scroll', handleScroll);

    function handleScroll(e){
        if(window.scrollY<50){
            setHeight(true)
            return
        }
        setHeight(false);
    }

    const Leave = ()=>{
        store.dispatch(LogOut())
    }    
    
    return (
        <Container $height={height}>
            <Content>
                <NameContainer onClick={()=>navigate('/perfil')}>
                    <ProfileImage src={user?.user?.foto ? user?.user?.foto : require("../../../../Assets/Images/profile.png")}/>
                    <NameText> {user?.user?.nome} </NameText>
                </NameContainer>
                <LogOutContainer onClick={()=> Leave()}>
                    <LogOutText>Sair</LogOutText>
                    <LogOutImage src={LogOutIcon}/>
                </LogOutContainer>
            </Content>
        </Container>
    );
}

export default MobileHeader;